
export const routes = [
  {
    path: '/home/login/test',
    name: 'home-login-test',
    component: () => import(
      '@/views/debug/UserDebug.vue'
    )
  },
  {
    path: '/home/login',
    name: 'home-login',
    component: () => import(
      '@/views/home/Login.vue'
    )
  },
  {
    path: '/home/register',
    name: 'home-register',
    component: () => import(
      '@/views/home/Register.vue'
    )
  },
  {
    path: '/home/userInfo',
    name: 'home-user-info',
    component: () => import(
      '@/views/home/UserInfo.vue'
    )
  },
  {
    path: '/home/screenplays',
    name: 'home-screenplays',
    component: () => import(
      '@/views/home/ScreenplayManage.vue'
    )
  },
  {
    path: '/home/creator/create',
    name: 'home-creator-create',
    component: () => import(
      '@/views/album/CreateForm.vue'
    )
  },
  {
    path: '/home/creator/',
    name: 'home-creator-manager',
    component: () => import(
      '@/views/album/Manager.vue'
    )
  },
  {
    path: '/home/creator/edit/:albumId',
    name: 'home-creator-edit',
    component: () => import(
      '@/views/album/AlbumEditor.vue'
    )
  }
]
export default routes
